// extracted by mini-css-extract-plugin
module.exports = {"loadingItem":"SkeletonPunchlistItem_loadingItem__2DcNb","added":"SkeletonPunchlistItem_added__1hi8m","skeletonContainer":"SkeletonPunchlistItem_skeletonContainer__UvbNW"};